import {createRouter, createWebHistory} from 'vue-router'
import admin from "@/views/AdminView.vue";
import SpravceUctuView from "@/views/SpravceUctuView.vue";
import ProjectView from "@/views/ProjectView.vue";
import authView from "@/views/AuthView.vue";
import {useAuth0} from "@auth0/auth0-vue";
import ModulesView from "@/views/ModulesView.vue";
import LogsView from "@/views/LogsView.vue";
import OrdersView from "@/views/OrdersView.vue";
import OrderDetailView from "@/views/OrderDetailView.vue";
import CustomersView from "@/views/CustomersView.vue";
import CustomerDetailView from "@/views/CustomerDetailView.vue";
import ProductsView from "@/views/ProductsView.vue";
import ProductDetailView from "@/views/ProductDetailView.vue";
import unauthorizedView from "@/views/Unauthorized.vue";
import {watch} from 'vue';
import AddressesView from "@/views/AddressesView.vue";
import AddressDetailView from "@/views/AddressDetailView.vue";

const router = createRouter({
    // import.meta.env.BASE_URL má v TS typ unknown v tomto projektu; přetypujeme na string
    history: createWebHistory(import.meta.env.BASE_URL as string),
    routes: [
        {
            path: '/',
            name: 'auth',
            component: authView
        },
        {
            path: '/:ucet/:project/admin/',
            name: 'admin',
            component: admin
        },
        {
            path: '/:ucet/sprava-uctu',
            name: 'spravaUctu',
            component: SpravceUctuView
        },
        {
            path: '/:ucet/:project/moduly',
            name: 'Moduly',
            component: ModulesView
        },
        {
            path: '/:ucet/projects',
            name: 'projects',
            component: ProjectView
        },
        {
            path: '/:ucet/:project/logs',
            name: 'logs',
            component: LogsView
        },
        {
          path: '/:ucet/:project/orders',
          name: 'orders',
          component: OrdersView
        },
        {
            path: '/:ucet/:project/order/:orderId',
            name: 'order-detail',
            component: OrderDetailView
        },
        {
            path: '/:ucet/:project/customers',
            name: 'customers',
            component: CustomersView
        },
        {
            path: '/:ucet/:project/customer/:customerId',
            name: 'customer-detail',
            component: CustomerDetailView
        },
        {
            path: '/:ucet/:project/products',
            name: 'products',
            component: ProductsView
        },
        {
            path: '/:ucet/:project/product/:productId',
            name: 'product-detail',
            component: ProductDetailView
        },
        {
            path: '/:ucet/:project/addresses',
            name: 'addresses',
            component: AddressesView
        },
        {
            path: '/:ucet/:project/addresses/:addressId',
            name: 'address-detail',
            component: AddressDetailView
        },
        {
            path: '/:pathMatch(.*)*',
            component: authView
        },
        {
            path: '/unauthorized',
            name: 'unauthorized',
            component: unauthorizedView
        }
    ]
})

router.beforeEach((to, from, next) => {

    const {isAuthenticated, loginWithRedirect, idTokenClaims} = useAuth0();
    console.log(idTokenClaims);
    if ((!isAuthenticated || !isAuthenticated.value) && to.name !== 'auth') {
        loginWithRedirect();
        return;
    }

    const roles = idTokenClaims.value?.['https://haxo.cz/roles'] ?? [];

    if (roles.length > 0 && !(roles.includes('Admin') || roles.includes('SuperAdmin')) && to.name !== 'unauthorized') {
        return next({name: 'unauthorized'});
    } else next();
})

/*router.beforeEach(async (to, from, next) => {
    // Get Auth0 reactive properties
    const { isLoading, isAuthenticated, loginWithRedirect, idTokenClaims } = useAuth0();

    // If Auth0 SDK is still loading, wait until it finishes to avoid repeatedly calling login
    if (isLoading && isLoading.value) {
        await new Promise<void>((resolve) => {
            const stop = watch(isLoading, (v) => {
                if (!v) {
                    stop();
                    resolve();
                }
            });
        });
    }

    // First: pokud uživatel není autentizovaný, přesměruj na login jednou
    if ((!isAuthenticated || !isAuthenticated.value) && to.name !== 'auth') {
        try {
            await loginWithRedirect({ appState: { target: to.fullPath } });
            // SDK provede přesměrování; nevoláme next() po redirectu
            return;
        } catch (err) {
            console.error('loginWithRedirect failed', err);
            return next({ name: 'auth' });
        }
    }

    // Nyní už je uživatel autentizovaný (nebo jsme na auth stránce) — bezpečně čteme role
    const roles = idTokenClaims && idTokenClaims.value && idTokenClaims.value['https://haxo.cz/roles'];
    if (roles && roles[0] === 'Customer' && to.name !== 'unauthorized') {
        return next({ name: 'unauthorized' });
    }

    // Ve všech ostatních případech pokračuj
    next();
})*/

export default router
